import { supabase } from '../lib/supabase';

interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
  serviceType: string;
}

export const submitContactForm = async (formData: ContactFormData) => {
  const webhookUrl = (process.env.REACT_APP_N8N_WEBHOOK_URL || '').trim();
  try {
    // 1) Si un webhook n8n est configuré, on l'utilise comme chemin principal
    if (webhookUrl) {
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        serviceType: formData.serviceType,
        meta: {
          submittedAt: new Date().toISOString(),
          source: 'website-contact-form',
        },
      };

      const resp = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        const text = await resp.text().catch(() => '');
        throw new Error(`n8n webhook error: ${resp.status} ${resp.statusText} ${text}`);
      }

      // 2) On tente un log Supabase (non bloquant)
      try {
        await supabase.from('contact_requests').insert([
          {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            message: formData.message,
            service_type: formData.serviceType,
            sent_to_n8n: true,
          },
        ]);
      } catch (logErr) {
        console.warn('Journalisation Supabase échouée (non bloquant):', logErr);
      }

      return { success: true };
    }

    // 3) Sinon, fallback: insertion Supabase comme avant
    const { data, error } = await supabase.from('contact_requests').insert([
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        service_type: formData.serviceType,
      },
    ]);

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error('Erreur lors de la soumission du formulaire :', error);
    return { success: false, error };
  }
};

export const getServiceTypes = async () => {
  try {
    // Si vous avez une table pour les types de services
    const { data, error } = await supabase
      .from('service_types')
      .select('*');
      
    if (error) throw error;
    
    return { success: true, data };
  } catch (error) {
    console.error('Erreur lors de la récupération des types de services :', error);
    return { success: false, error };
  }
};
